<template>
  <span v-if="info">
    <div :class="classes">
      <div class="icon"><i :class="iconClass"></i></div>
      <div class="information">
        <div class="name" v-b-tooltip.hover :title="info.name">{{ info.name }}</div>
        <div class="filesize" v-if="info.size">
          {{bytesToSize(info.size)}}
        </div>
        <div class="filesize" v-if="!info.size">
          {{base64ToSize(info.content)}}
        </div>
         <div class="remove" v-if="percent != '100'">
          <i class="fal fa-trash-alt pr-2 clickable" @click="removeFile(index)"></i>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
export default {
  props: {
    item: {
      default: null,
      type: [Object, File]
    },
    index: {
      default: 0,
      type: Number,
    },
    percent: {
      default: 0,
      type: Number,
    },
    isError: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    uploading: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    }
  },
  data() {
    return {
      loading: false,
      info: this.item,
      blob: null
    };
  },
  methods: {
    removeFile(index) {
      this.$emit("removeFile",index);
    },
    base64ToSize(content)
    {
      if(content != null)
      {
        var decoded = atob(content);
        return this.bytesToSize(decoded.length);
      }else{
        return 0;
      }
    }
  },
  computed: {
    iconClass(){
      if(this.uploading && this.isError == false){
        return ["fal","fa-spinner"];  
      }
      return ["fal","fa-file"];
    },
    classes(){
      if(this.isError)
      {
        return ["attachment","attachment-upload-error"];
      }else{
        if(this.percent == 100)
        {
          return ["attachment","attachment-upload-done"];
        }
        return ["attachment"];
      }
    }
  }
};
</script>